import React, { useEffect, useState } from "react";

// MUI
import { DataGrid } from "@mui/x-data-grid";
import { Box, Stack } from "@mui/material";

// Local
import { tableStyle } from "../../theme";
import SubSettingsHeader from "../../components/UI/SubSettingsHeader";
import useApiHttp from "../../hooks/use-http";
import { isoToInformalData } from "../../util/helper";
import { Button, Icon, Text } from "@jds/core";
import EmptyState from "../../components/NoData/EmptyState";
import Loader from "../../components/UI/Loader/Loader";

export default function SubscriptionOrderHistoryPage() {
  const [orderHistoryData, setOrderHistoryData] = useState([]);
  const { sendRequest: getOrderHistory, isLoading: isOrderHistoryLoading } =
    useApiHttp();

  const getOrderHistoryHandler = () => {
    getOrderHistory({
      url: `chargeit/subscription`,
      base: "MEDIA",
    }, () => { }, (data) => { setOrderHistoryData(data?.data) });
  };

  const columns = [
    { field: "s_no", headerName: "S.No", width: 80, editable: true },
    {
      field: "startAt",
      headerName: "Date issued",
      width: 150,
      editable: false,
      renderCell: (val) => {
        console.log(val?.row?.startAt)
        const normalDate = isoToInformalData(val?.row?.startAt)
        return <Text text={normalDate} appearance="body-s" />
      }
    },
    {
      field: "name",
      headerName: "Plan",
      width: 150,
      editable: false,

    },
    // {
    //   field: "price",
    //   headerName: "Amount",
    //   width: 250,
    //   editable: false,
    // },
    // {
    //   field: "invoice",
    //   headerName: "Invoice",
    //   width: 220,
    //   editable: false,
    //   renderCell: (val) => {
    //     console.log(val?.row?.startAt);
    //     return (
    //       <Stack direction="row" alignItems={'center'} sx={{ cursor: "pointer", gap: '4px' }} onClick={() => { console.log('invoice button') }}>
    //         <Icon ic="IcDocument" />
    //         <Text text={'Download'} color="primary_60" appearance="body_s_bold" />
    //       </Stack>
    //     )
    //   }
    // },
  ];


  useEffect(() => {
    console.log('first')
    getOrderHistoryHandler();
  }, []);
  return (
    <div>
      <SubSettingsHeader heading="Order History" />
      {isOrderHistoryLoading ? <Loader size="medium" /> : orderHistoryData.length > 0 ?
        <Box mt={4}>
          <DataGrid
            columns={columns}
            rows={orderHistoryData.map((val, i) => ({ ...val, id: val?.subscriptionId, s_no: i + 1, name: val?.plan?.name }))}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[10, 15]}
            disableColumnMenu
            disableRowSelectionOnClick
            loading={isOrderHistoryLoading}
            sx={tableStyle}
          />
        </Box>
        : <EmptyState title="No Subscription found." action={false} />
      }
    </div>
  );
}
